import { Injectable } from '@angular/core';
import { ExportContext, ExportFileFormat, ExportRange, ExportService } from 'app/layout/export-overlay';
import { buildQuery, page, seed } from '@albatrosdeveloper/ave-utils-npm/lib/utils/query.util';
import { DocumentRangeAttributes, EmissionPointAttributes } from '@albatrosdeveloper/ave-models-package';
import { takeUntil } from 'rxjs';
import get from 'lodash-es/get';
import ceil from 'lodash-es/ceil';
import { format, parseISO } from 'date-fns';
import { EmissionPointService } from '../emission-point.service';
import { EMISSION_POINT_EXPORT_ID, EMISSION_POINT_TITLE, LOCALIZED_PROPERTIES } from './emission-point.constants';

@Injectable()
export class EmissionPointExport {
  constructor(
    private exportService: ExportService,
    private emissionPointService: EmissionPointService,
  ) { }

  private transformItem(item: EmissionPointAttributes) {
    return {
      name: item?.name || '',
      rute: item?.subRoute?.name || '',
      company: item?.company?.name || '',
      salesOffices: this.getSalesOffices(item),
    };
  }

  private getSalesOffices(item: EmissionPointAttributes): string {
    // Si no existe salesOffices
    if (!item?.salesOffices) {
      return '';
    }

    // Si es un array
    if (Array.isArray(item.salesOffices)) {
      const names = item.salesOffices.map((office, index) => {
        return office?.name || '';
      }).filter(name => name !== '');

      const result = names.join(', ');
      return result;
    }

    return '';
  }

  export(format: ExportFileFormat, range: ExportRange, totalItems: number, pageSize: number, pageIndex: number) {
    const totalPages = ceil(totalItems / pageSize) + 1;
    this.exportService.task({
      id: EMISSION_POINT_EXPORT_ID,
      title: EMISSION_POINT_TITLE,
      format: format,
      iterations: range === ExportRange.AllPages ? totalPages : 1,
      start: (ctx: ExportContext) => {
        ctx.processor.localizeItemProperties(EMISSION_POINT_TITLE, LOCALIZED_PROPERTIES);
      },
      next: (ctx: ExportContext) => {
        const currentPage = range === ExportRange.AllPages ? ctx.iteration : pageIndex;
        this.emissionPointService.findByFilter(buildQuery(
          seed(this.emissionPointService.currentFilter), page(currentPage, pageSize)
        ), { contextHeader: 'export' }).pipe(takeUntil(ctx.stopped)).subscribe((response) => {
          get(response, 'data.0.data', []).map((item) => {
            ctx.processor.addToSection(EMISSION_POINT_TITLE, this.transformItem(item));
          });
          ctx.next();
        });
      },
    }).start();
  }

  canStartTask() {
    if (this.exportService.taskIsActive(EMISSION_POINT_EXPORT_ID)) {
      this.exportService.setVisible(true);
      return false;
    }
    return true;
  }
}